import React, { useRef, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import Avatar from "@mui/material/Avatar";
import useClickOutside from "../../../../hooks/useClickOutside";
import { ReactComponent as Dropdown } from "../../../../assets/images/dropdown-arrow.svg";
import { colorCodesForAvatar } from "../../../../constants/index";
import DropdownSelectionTick from "../DropdownSelectionTick";
import { dropdownOptionListSx, dropdownOptionRowSx, dropdownPanelSx, PeopleSearchIcon, searchFieldSx, triggerSx } from "../Customers/customersFilterUiShared";

export default function TeamAssignGroupSelect({ value, onChange, groups = [] }) {
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const wrapperRef = useRef(null);

  useClickOutside(wrapperRef, () => {
    setOpen(false);
    setSearchTerm("");
  });

  const selected = groups.find((g) => g.id === value);
  const filtered = groups.filter((g) =>
    (g.label || "").toLowerCase().includes(searchTerm.toLowerCase())
  );

  const getAvatarColor = (name) => {
    if (!name) return colorCodesForAvatar[0];
    const idx = name.charCodeAt(0) - 65;
    return colorCodesForAvatar[idx >= 0 && idx < colorCodesForAvatar.length ? idx : 0];
  };

  return (
    <Box
      ref={wrapperRef}
      sx={{ position: "relative", display: "inline-block", minWidth: 136, flexShrink: 0 }}
    >
      <Box
        sx={{ ...triggerSx, height: 32, minWidth: 136, padding: "0 12px" }}
        onClick={() => setOpen((o) => !o)}
      >
        <Typography
          noWrap
          sx={{ color: "#405261", fontSize: 14, fontFamily: "Inter", fontWeight: 400, flex: 1 }}
        >
          {selected ? selected.label : "Assign Group"}
        </Typography>
        <Dropdown
          style={{
            transform: open ? "rotate(180deg)" : "rotate(0)",
            transition: "transform 0.2s",
            width: 16,
            height: 16,
            flexShrink: 0,
          }}
        />
      </Box>
      {open && (
        <Box sx={dropdownPanelSx}>
          <Box sx={{ flexShrink: 0 }}>
            <TextField
              fullWidth
              autoFocus
              variant="outlined"
              placeholder="Search groups"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <PeopleSearchIcon style={{ width: 16, height: 16, display: "block" }} />
                  </InputAdornment>
                ),
              }}
              sx={searchFieldSx}
            />
          </Box>
          <Box sx={dropdownOptionListSx}>
            {filtered.map((group) => {
              const isSelected = value === group.id;
              return (
                <Box
                  key={group.id}
                  onClick={() => {
                    onChange(group.id);
                    setOpen(false);
                    setSearchTerm("");
                  }}
                  sx={dropdownOptionRowSx({ selected: isSelected })}
                >
                  <Avatar
                    sx={{
                      width: 32,
                      height: 32,
                      fontSize: 14,
                      bgcolor: getAvatarColor(group.label),
                      flexShrink: 0,
                    }}
                  >
                    {(group.label || "?").charAt(0).toUpperCase()}
                  </Avatar>
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography
                      sx={{
                        fontSize: 14,
                        color: "#061522",
                        fontFamily: "Inter",
                        fontWeight: 500,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {group.label}
                    </Typography>
                  </Box>
                  {isSelected && <DropdownSelectionTick />}
                </Box>
              );
            })}
          </Box>
        </Box>
      )}
    </Box>
  );
}
